import { AppUser } from 'fobclient/lib/entity'
import Organisationseinheit from './Organisationseinheit'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('AppUser')

export default {
  label: 'App User',
  route: 'appuser',
  className: 'appUser',
  class: AppUser,
  fields: [
    Fields.String('userName'),
    {
      ...Fields.UneditableDate('lastLogin'),
      inEditView: false
    },
    Fields.SimpleMultiReference(
      'applicationRoles',
      'folder-open',
      {
        route: 'approle',
        className: 'appRole',
        fields: [
          {
            field: 'name',
            table: true
          }
        ]
      }
    ),
    Fields.UneditableSimpleMultiReference('organisationseinheiten', 'sitemap', Organisationseinheit, false),
    Fields.SimpleMultiReference('zstzlOrganisationseinheiten', 'sitemap', Organisationseinheit, false),
    {
      label: 'AppUser.form.forscher',
      field: 'forscher',
      type: Boolean
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/AppUser.js